import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateBadgeCreateLayoutRoute() {
  return <ModalStack />;
}
